export default "__VITE_ASSET__raWtxkGw__"